import React, { useState } from "react";
import "../../styling/component.css";
import Mobile from "../mobile-nav-header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import GoogleCSE from "../GoogleCSE";
import "../seach-bar.css";

export default function NavigationHeader() {
  // State to manage the visibility of the Mobile component
  const [mobileVisible, setMobileVisible] = useState(false);

  // Function to toggle the visibility of the Mobile component
  const toggleMobile = () => {
    setMobileVisible(!mobileVisible);
  };

  return (
    <div className="header">
      <div className="navigation-header">
        <a href="/">
          <img
            src="https://beirabrush-2024.sgp1.digitaloceanspaces.com/cdn.beirabrush.com-uploads/Beira-Brush-3-300x163.jpg"
            alt="Logo"
            className="logo"
          />
        </a>
        <div className="nav-links">
          <a href="/" className="nav-link">
            HOME
          </a>
          <div className="dropdown">
            <button className="dropbtn">ABOUT BEIRA BRUSH +</button>
            <div className="dropdown-content">
              <p></p>
              <a href="/company/">COMPANY</a>
              <a className="top-border" href="/quality/">
                QUALITY
              </a>
              <a className="top-border" href="/sustainability/">
                SUSTAINABILITY
              </a>
            </div>
          </div>
          <a href="/store/" className="nav-link2">
            PRODUCT RANGE
          </a>
          <a href="/factories/" className="nav-link">
            FACTORIES
          </a>
          <a href="/contact-us/" className="nav-link">
            CONTACT
          </a>
          {/* <a href="/faq-page/" className="nav-link">
            FAQ
          </a> */}
          <div>
            <GoogleCSE />
          </div>
        </div>
        {/* Add an onClick event to toggle the Mobile component */}
        <button type="button" className="menu-icon" onClick={toggleMobile}>
          {mobileVisible ? (
            <FontAwesomeIcon icon={faXmark} style={{ color: "#776e33" }} />
          ) : (
            <FontAwesomeIcon icon={faBars} style={{ color: "#776e3a" }} />
          )}
        </button>
        {/* Render the Mobile component conditionally based on mobileVisible */}
        {mobileVisible && (
          <div className="menu-icon2">
            <Mobile />
          </div>
        )}
      </div>
    </div>
  );
}
